import { render } from "./TenantManagement.vue?vue&type=template&id=5256c43f&scoped=true"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"

import "./TenantManagement.vue?vue&type=style&index=0&id=5256c43f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5256c43f"]])

export default __exports__